export const headerGardian = {
    title: "Gestion du gardien",
    submodules: [
        createData(0, "Liste des gardiens", "/gardian_list"),
        createData(1, "Configurer jour de repos", "/gardian_add"),
            createData(1, "Suivi des jours de repos", "/gardian_visual"),
    ],
  };
  
  function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
  }
  